// extracted by mini-css-extract-plugin
export default {"wrapper":"privacyAgree_wrapper__cOAMV","container":"privacyAgree_container__HPWQD"};